import type { Components, Theme } from "@mui/material/styles";

export const MuiSlider: Components<Theme>["MuiSlider"] = {
    defaultProps: {},
    styleOverrides: {
        root: {
            color: "var(--mui-palette-gray-800)",
            "& .MuiSlider-thumb": {
                width: "16px",
                height: "16px",
                backgroundColor: "var(--mui-palette-gray-800)",
                transitionProperty: "transform, box-shadow, background-color, width, height",
                transitionDuration: "0.2s",
            },
            "& .MuiSlider-thumb:hover": {
                boxShadow: "none",
            },
            "& .MuiSlider-thumb.Mui-active": {
                boxShadow: "none",
                width: "20px",
                height: "20px",
            },
            "& .MuiSlider-thumb:focus": {
                boxShadow: "rgb(191, 191, 191) 0px 0px 0px 3px",
            },
            "& .MuiSlider-thumb:focus-visible": {
                boxShadow: "rgb(191, 191, 191) 0px 0px 0px 3px",
            },
            "& .MuiSlider-thumb.Mui-focusVisible": {
                boxShadow: "rgb(191, 191, 191) 0px 0px 0px 3px",
            },
            "& .MuiSlider-rail": {
                backgroundColor: "var(--mui-palette-gray-700)",
                borderRadius: "4px",
                height: "4px",
                transition: "none",
            },
            "& .MuiSlider-track": {
                transition: "none",
            },
            "& .MuiSlider-mark": {
                backgroundColor: "#fff",
                width: "1px",
                height: "4px",
                borderRadius: "0",
                opacity: "1",
            },
        },
    },
};
